import React from "react";
import clsx from "clsx";

const LogOutIcon = ({ active }) => {
  return (
    // <svg
    //   className={clsx("w-6 h-6 fill-current", { "text-gray-500": !active }, { "text-blue-400": active })}
    //   xmlns="http://www.w3.org/2000/svg"
    //   viewBox="0 0 24 24"
    //   width="24"
    //   height="24"
    // >
    //   <path fill="none" d="M0 0h24v24H0z" />
    //   <path d="M12 13l6 9H6l6-9zm0 3.6L9.74 20h4.52L12 16.6zm-1.06-6.04a1.5 1.5 0 1 1 2.12-2.12 1.5 1.5 0 0 1-2.12 2.12zM5.281 2.783l1.415 1.415a7.5 7.5 0 0 0 0 10.606l-1.415 1.415a9.5 9.5 0 0 1 0-13.436zm13.436 0a9.5 9.5 0 0 1 0 13.436l-1.415-1.415a7.5 7.5 0 0 0 0-10.606l1.415-1.415zM8.11 5.611l1.414 1.414a3.5 3.5 0 0 0 0 4.95l-1.414 1.414a5.5 5.5 0 0 1 0-7.778zm7.778 0a5.5 5.5 0 0 1 0 7.778l-1.414-1.414a3.5 3.5 0 0 0 0-4.95l1.414-1.414z" />
    // </svg>

    <svg
      xmlns="http://www.w3.org/2000/svg"
      className={clsx(
        " w-10 h-7 fill-current text-white ",
        { "text-white-500": !active },
        { "text-green-400": active }
      )}
      viewBox="0 0 24 24"
      fill="none"
      stroke="#000000"
      strokeWidth={"2"}
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <path
        d="M10 3H6a2 2 0 0 0-2 2v14c0 1.1.9 2 2 2h4M16 17l5-5-5-5M19.8 12H9"
        stroke="#3d66c4"
      />
    </svg>
  );
};

export default LogOutIcon;
